<template>
  <div>
    <v-card elevation="0" height="305" class="overflow-auto">
      <v-card-title class="size-18 pb-0">
        <v-avatar color="amber lighten-5" rounded="lg" size="26" class="mt-n1">
          <v-icon dark small color="amber">mdi-order-bool-descending</v-icon>
        </v-avatar>&nbsp;&nbsp;签订项目</v-card-title>
      <v-list two-line v-if="items.length > 0" class="pt-0">
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <v-list-item-avatar class="blue lighten-1" size="35">
              <span class="white--text font-weight-bold">{{item.number}}</span>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="size-14" v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index < items.length - 1"></v-divider>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>

  export default {
    name: 'ProductIndex',
    props: {
      items: {
        type: Array
      }
    },
    components: {
    },
    data() {
      return {
        productHeaders: [
          {
            text: '项目名称',
            align: 'left',
            width: 250,
            value: 'name',
            sortable: false
          },
          {
            text: '签订数量',
            align: 'center',
            width: 60,
            value: 'number',
            sortable: true
          }
        ]
      }
    }
  }
</script>

<style lang="scss">
.ranking-title{
  float: left;
}
.ranking-chip{
  float: right;
}
</style>
